import axios from './defaultClient';

const nameSpace = '/ep/v1/blogs';

export const GetPosts = async (args) => {
	return await axios.get(nameSpace + '/', {
		params: args,
	});
};

export const GetSliders = async (args) => {
	return await axios.get(nameSpace + '/sliders', {
		params: args,
	});
};

export const GetPost = async (args) => {
	return await axios.get(nameSpace + '/' + args.ID, {
		params: args,
	});
};

export const GetSeriesNum = async (args) => {
	return await axios.get(nameSpace + '/series/num', {
		params: args,
	});
};

export const GetTags = async (args) => {
	return await axios.get(nameSpace + '/tags', {
		params: args,
	});
};

export const GetAuthors = async (args) => {
	return await axios.get(nameSpace + '/authors', {
		params: args,
	});
};
